import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { parse, stringify } from 'flatted';
import cmsData from 'Lib/cmsData';
import apiData from 'Lib/apiData';
import PartnersSection from '../../components/partners/partners-section';
import PartnersFormSection from '../../components/partners/partners-form-section';
import Seo from '../../components/seo';

export default class Partners extends Component {

  static async getInitialProps() {
    const contentParams = {
      content_type: 'partnersPage',
    };

    const [data, form] = await Promise.all([
      cmsData(contentParams),
      apiData('/v1/lists/1'),
    ]);

    const flatData = data && data[0] ? stringify(data[0]) : null;

    return { data: flatData, form };
  }

  render() {
    const data = this.props.data && parse(this.props.data);
    const { form } = this.props;

    return (
      <main>
        <Seo seo={data.fields.seo} />
        <Helmet>
          <link
            rel="preload"
            href="https://cdnjs.cloudflare.com/ajax/libs/gsap/2.1.3/plugins/ScrollToPlugin.min.js"
            as="script"
          />
          <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/2.1.3/plugins/ScrollToPlugin.min.js" defer />
        </Helmet>
        <PartnersSection
          title={data.fields.heroTitle}
          description={data.fields.heroDescription}
          partnerList={data.fields.partnerList}
        />

        <PartnersFormSection
          title={data.fields.becomeAPartnerTitle}
          description={data.fields.becomeAPartnerDescription}
          form={form}
          formTitle={data.fields.formTitle}
          formSuccess={data.fields.formSuccessMessage}
        />
      </main>
    );
  }

}
